import { render, staticRenderFns } from "./UserOtherModal.vue?vue&type=template&id=16045cff&scoped=true&"
import script from "./UserOtherModal.vue?vue&type=script&lang=js&"
export * from "./UserOtherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16045cff",
  null
  
)

export default component.exports